import { observer } from 'mobx-react';

import { CategoryGamesGrid } from '../../../../components/GamesList/CategoryGamesGrid';
import { Games } from '../../../../components/GamesList/Games';
import { SearchGamesGrid } from '../../../../components/GamesList/SearchGamesGrid';
import { GamesSearchHistory } from '../../../../components/GamesSearchHistory/GamesSearchHistory';
import { HOME_CATEGORY_ID } from '../../../../stores/categories/CategoriesStore';
import { useStores } from '../../../../stores/useStores';

import styles from './GamesView.module.scss';

function GamesViewComponent() {
  const { categoriesStore, gamesSearchStore } = useStores();

  const { isSearchInputOpenV2 } = gamesSearchStore;

  return (
    <div className={styles.container}>
      <div className={styles.gamesContentBackground} />

      <div className={styles.wrapper}>
        {isSearchInputOpenV2 && <GamesSearchHistory />}
        {isSearchInputOpenV2 || gamesSearchStore.isProviderSearch ? (
          <SearchGamesGrid />
        ) : categoriesStore.currentId === HOME_CATEGORY_ID ? (
          <Games
            carouselClassName={styles.carousel}
            carouselLeftArrowClassName={styles.carouselLeftArrow}
            carouselRightArrowClassName={styles.carouselRightArrow}
          />
        ) : (
          <CategoryGamesGrid />
        )}
      </div>
    </div>
  );
}

export const GamesView = observer(GamesViewComponent);
